
export function getNextAlphaString(input: string) {
    const alphabet = 'abcdefghijklmnopqrstuvwxyz';
    let result = '';
    let carry = 1;

    for (let i = input.length - 1; i >= 0; i--) {
        const char = input[i];
        const index = alphabet.indexOf(char);
        const sum = index + carry;

        if (sum >= alphabet.length) {
            carry = 1;
            result = alphabet[sum % alphabet.length] + result;
        } else {
            carry = 0;
            result = alphabet[sum] + result;
        }
    }

    if (carry > 0) {
        result = alphabet[carry - 1] + result;
    }

    return result;
}